<pr-modal-confirm
  #invalidNifModal
  [title]="'NIF non valide'"
  [comment]="
    'Le code nif que vous avez saisi ne semble pas conforme. Voulez-vous quand même l\'ajouter ?'
  "
  [labelConfirm]="'Confirmer'"
  [labelCancel]="'Corriger'"
  (onConfirm)="onConfirmInvalidNif()"
  (onConfirmOptionnal)="onCancelInvalidNif()"
  display="warning"
>
</pr-modal-confirm>
<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      @for (owner of owners.controls; track owner; let index = $index) {
        <ng-container [formGroup]="owner">
          <div class="row">
            <div class="col-md-12">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <pr-input-column label="Numéro fiscal" [derrors]="derrors">
                <input formControlName="userNifCode" type="text" />
                <pr-button mat-button (click)="openDialog()">
                  <pr-icon name="fa-question-circle"></pr-icon>
                </pr-button>
              </pr-input-column>
            </div>
          </div>
        </ng-container>
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
